import React, { useEffect, useState } from 'react';
import { getLenis, reducedMotion } from '../../hooks/useLenis.js';
import './BackToTop.css';

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Lenis drives native scrolling, so plain scroll events see its position.
    const onScroll = () => setVisible(window.scrollY > window.innerHeight);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = (event) => {
    const lenis = getLenis();
    if (lenis) {
      lenis.scrollTo(0, { duration: 1.2 });
    } else {
      window.scrollTo({ top: 0, behavior: reducedMotion() ? 'auto' : 'smooth' });
    }
    // A keyboard press (detail === 0) would otherwise leave focus at the bottom
    // of the page; hand it to the first element, the skip link.
    if (event.detail === 0) {
      document.querySelector('.skip')?.focus({ preventScroll: true });
    }
  };

  return (
    <button
      type="button"
      className="back-to-top"
      data-visible={visible ? 'true' : 'false'}
      aria-label="Back to top"
      tabIndex={visible ? 0 : -1}
      onClick={scrollToTop}
    >
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path
          d="M12 19V5M5.5 11.5 12 5l6.5 6.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};
